import { MsalAuthError } from "@/common/acs/error";
import {
	authenticateMsal,
	teamsUserRequest,
} from "@/common/authentication/msalConfig";
import { Client, Controller, Endpoint, mapUrl } from "@/repository";
import { RefreshStatus, UserShortProfileDto } from "@/repository/models";

export const userShorProfileQueryKey = "userShortProfile";

export const getUserShortProfile = (): Promise<UserShortProfileDto> =>
	Client.instance.get<UserShortProfileDto>(
		mapUrl(Controller.Account, Endpoint.Profile)
	);

export const refreshAccount = (deleteOngoingCall: boolean): Promise<RefreshStatus> =>
	Client.instance.post(mapUrl(Controller.Account, Endpoint.RefreshWorkload), deleteOngoingCall);

export const checkThereIsACallInProgress = (userId?: string | undefined): Promise<boolean> =>
	Client.instance.post(mapUrl(Controller.Account, Endpoint.IsAnyCallInProgress), userId);

export const getGraphApiToken = (idToken: string): Promise<string> =>
	Client.instance.post(
		mapUrl(Controller.Account, Endpoint.GraphToken),
		idToken
	);

export const checkCanGenerateSummary = (): Promise<boolean> =>
	Client.instance.get<boolean>(
		mapUrl(Controller.Account, Endpoint.CanGenerateSummary)
	);

export const getAcsToken = async (): Promise<string> => {
	const teamsUser = await authenticateMsal(teamsUserRequest);
	if (!teamsUser?.accessToken) {
		throw new MsalAuthError("MSAL authentication failed or user cancelled.");
	}

	return Client.instance.post(
		mapUrl(Controller.Account, Endpoint.AcsToken),
		teamsUser?.accessToken
	);
};
